var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('bill.budget')}}),_c('page-body',[_c('budget-list',{attrs:{"id":"BudgetList"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }